(function($) {
	$.fn.addToCart=function(options) {
		var $this=$(this);

		var options=$.extend({
			fadetime: 170,
			quantity: 1,

			onQuantity: null
		}, options);

		var adding=false;

		var old=$this.text();

		$this.click(function(e) {
			e.preventDefault();

			if (adding)
				return;

			adding=true;

			$('body').trigger('cartUpdateInit');

			var quantity=options.quantity;

			if (options.onQuantity!==null)
				quantity=options.onQuantity();

			$.post('/cartapi/'+options.id+'/add', {
				quantity: quantity
			}, function() {
				$this.addClass('addbutton--added');

				window.setTimeout(function() {
					$this.removeClass('addbutton--added');
				}, 2000);

				adding=false;

				if (typeof fbq !== 'undefined' && CookieConsent.getCookie().categories.includes('marketing')) {
					fbq('track', 'AddToCart');
				}

				$('body').trigger('cartUpdate');
			});
		});
	}

	$(document).ready(function() {
		$('body').on('cartUpdateInit', function() {
			// $('#cartsummary').ajaxLoader();
		});

		$('body').on('cartUpdate', function(e, oncomplete) {
			$.get('/cartapi/info', function(info) {
				$('.header__cartinfo span').text(info.total);

				if (oncomplete != null) {
					oncomplete();
				}
			});
		});

		$('.addbutton').each(function() {
			var $this=$(this);

			$this.addToCart({
				id: $this.data('id')
			});
		});
	});
})(jQuery);
